"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeVrm = exports.vrmUnwantedCharsMatcherRegex = void 0;
exports.vrmUnwantedCharsMatcherRegex = /[^A-Z0-9]/gi;
const sanitizeVrm = (vrm) => vrm.normalize('NFD').replace(exports.vrmUnwantedCharsMatcherRegex, '');
exports.sanitizeVrm = sanitizeVrm;
//# sourceMappingURL=vehicle.js.map